import React, { useState } from 'react';
import styles from './chatbot.module.scss';
import { gerarDescricaoIA } from '../../services/chatService.ts';


interface Message {
  id: number;
  text: string;
  sender: 'user' | 'bot';
}

export function Chatbot() {
  const [messages, setMessages] = useState<Message[]>([
    { id: 1, text: "Olá! Sou seu assistente de turismo em Sergipe. Como posso te ajudar hoje?", sender: 'bot' }
  ]);
  const [inputValue, setInputValue] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  
  // Tela de carregamento enquanto a API responde
  const [isLoading, setIsLoading] = useState(false);

  
  const handleSendMessage = async () => {
    if (!inputValue.trim() || isLoading) return;

    const userText = inputValue;
    const newUserMessage: Message = {
      id: Date.now(),
      text: userText,
      sender: 'user'
    };

    setMessages((prev) => [...prev, newUserMessage]);
    setInputValue('');
    setIsLoading(true); // Digitando...

    try {
      
      const respostaDaIA = await gerarDescricaoIA(userText);
      
      const botMessage: Message = {
        id: Date.now() + 1,
        text: respostaDaIA,
        sender: 'bot'
      };

      setMessages((prev) => [...prev, botMessage]);
    } catch (error) {
      // Se o servidor dele estiver desligado ou der erro mostra esse aviso 
      const errorMessage: Message = {
        id: Date.now() + 1,
        text: "Ops! Tive um problema para me conectar ao assistente. Tente novamente em instantes.",
        sender: 'bot'
      };
      setMessages((prev) => [...prev, errorMessage]);
    } finally {
      setIsLoading(false); 
    }
  };

  if (!isOpen) {
    return (
      <button className={styles.floatingButton} onClick={() => setIsOpen(true)}>
        💬 Chat
      </button>
    );
  }

  return (
    <div className={styles.chatbotContainer}>
      <div className={styles.chatHeader}>
        <h3>Assistente Virtual</h3>
        <button className={styles.minimizeButton} onClick={() => setIsOpen(false)}>
          ➖
        </button>
      </div>

      <div className={styles.messagesWindow}>
        {messages.map((msg) => (
          <div 
            key={msg.id} 
            className={`${styles.messageBubble} ${msg.sender === 'user' ? styles.user : styles.bot}`}
          >
            {msg.text}
          </div>
        ))}

        {/* BOLHA DE CARREGAMENTO SE ESTIVER ESPERANDO O BACKEND */}
        {isLoading && (
          <div className={`${styles.messageBubble} ${styles.bot}`}>
            <span className={styles.typingIndicator}>Digitando...</span>
          </div>
        )}
      </div>

      <div className={styles.inputArea}>
        <input 
          type="text" 
          placeholder={isLoading ? "Aguardando resposta..." : "Digite sua dúvida aqui..."} 
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && handleSendMessage()}
          disabled={isLoading} // Bloqueia o input 
        />
        <button onClick={handleSendMessage} disabled={isLoading}>Enviar</button>
      </div>
    </div>
  );
}